import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApolloError } from '@apollo/client';

import { getFleetDevice } from '../../../service/graphql/machine/getFleetDevice';

import { AsyncThunkConfig } from '../../store';

import { IMachineDetails } from '../types';

interface ErrorWithCode {
  errorCode?: string;
}

export const getMachineThunk = createAsyncThunk<IMachineDetails, string, AsyncThunkConfig>(
  'machineDetails/getMachine',
  async (fleetDeviceId, { getState, rejectWithValue }) => {
    const {
      launchDarkly,
      selectedAccount: { activeAccountId },
    } = getState();

    if (!activeAccountId) {
      throw new Error('No accounts or user found.');
    }

    try {
      const result = await getFleetDevice(launchDarkly.data, fleetDeviceId);
      if (!result.subCategory?.category && result.categoryText === 'Miscellaneous') {
        result.subCategory = {
          defaultDisplayName: 'Miscellaneous',
          key: 'miscellaneous',
          category: {
            defaultDisplayName: 'Miscellaneous',
            key: 'miscellaneous',
          },
        };
      }
      return result;
    } catch (error) {
      let errorCode: string | undefined;

      if (error instanceof ApolloError) {
        // Extract error code from GraphQL error extensions
        const graphqlError = error.graphQLErrors?.[0];
        errorCode =
          (graphqlError?.extensions?.code as string) ||
          graphqlError?.extensions?.status?.toString() ||
          error.networkError?.message?.match(/\d{3}/)?.[0];
      } else if ((error as any).graphQLErrors) {
        // Handle custom error thrown from getFleetDevice
        const graphqlError = (error as any).graphQLErrors[0];
        errorCode = (graphqlError?.extensions?.code as string) || graphqlError?.extensions?.status?.toString();
      }

      return rejectWithValue({ errorCode } as ErrorWithCode);
    }
  },
);
